const emitir_relacao_de_alunos_nao_enturmados = {
  path: "/permitir-consultar-alunos-matriculados-por-escola-turma",
  redirect: "/permitir-consultar-alunos-matriculados-por-escola-turma",
  meta: {
    breadCrumb:
      "Processo de Matrículas - Permitir Consultar Alunos Matriculados Por Escola/Turma",
  },
  children: [
    {
      path: "/emitir-relacao-de-alunos-nao-enturmados",
      name: "emitir-relacao-de-alunos-nao-enturmados",
      component: () =>
        import(
          "@/views/EmitirRelacaoDeAlunosNaoEnturmados/EmitirRelacaoDeAlunosNaoEnturmados.vue"
        ),
    },
  ],
};

export { emitir_relacao_de_alunos_nao_enturmados };
